import React from 'react';
import { Sparkles, History, Info } from 'lucide-react';

const FeatureCard = ({ icon, title, desc }) => (
  <div className="bg-stone-800/50 p-8 rounded-2xl border border-stone-700 hover:border-orange-600 transition group">
    <div className="mb-6 transform group-hover:scale-110 transition duration-300">
      {icon}
    </div>
    <h3 className="text-xl font-bold mb-3 text-orange-100">{title}</h3>
    <p className="text-stone-400 text-sm leading-relaxed">{desc}</p>
  </div>
);

const Specialties = () => {
  return (
    <section className="py-20 bg-stone-900 text-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4">Devasthanam Specialties</h2>
          <p className="text-orange-400 font-medium">Why devotees travel from all over India to Chandippa</p>
        </div>
        <div className="grid md:grid-cols-3 gap-10">
          <FeatureCard 
            icon={<Sparkles className="text-orange-500" />}
            title="Emerald Brilliance"
            desc="The Shivalingam is carved from a single Marakatha stone, known for its unique green luminescence during the morning Surya Abhishekam."
          />
          <FeatureCard 
            icon={<History className="text-orange-500" />}
            title="Ancient Scripts"
            desc="The temple walls feature 11th-century inscriptions detailing the grants given by the Western Chalukya kings for its maintenance."
          />
          <FeatureCard 
            icon={<Info className="text-orange-500" />}
            title="Mystic Stone"
            desc="Witness the 'Chamatkara Shila' inside the complex—a heavy stone that rotates freely despite its immense weight."
          />
        </div>
      </div>
    </section>
  );
};

export default Specialties;